import { Select } from "../../../atoms/Form";
import { type ConstructedSelect } from "../types";

export const FIELD_NAME_BUBBLE_SELECT = "bubbleSelect";

// Centralized strings for internationalization
const DEFAULT_LABEL = "School";
const tPleaseSelectDistrict = "Please select a district";
const tPleaseSelectOrganization = "Please select an organization";
const tIsRequired = "$label is required";
const tPleaseSelectGeneric = "Please select a $label";

export interface BubbleSelectProps extends Omit<ConstructedSelect, "label"> {
  label?: string;
}

export const BubbleSelect = ({
  required,
  selectItems,
  selectProps,
  label = DEFAULT_LABEL,
  ...props
}: BubbleSelectProps) => {
  const getRequiredMessage = () => {
    // Handle special cases for different contexts
    if (label.toLowerCase().includes("parent")) {
      return tIsRequired.replace("$label", label);
    }
    if (label.toLowerCase().includes("district")) {
      return tPleaseSelectDistrict;
    }
    if (label.toLowerCase().includes("organization")) {
      return tPleaseSelectOrganization;
    }
    // Default case
    return tPleaseSelectGeneric.replace("$label", label.toLowerCase());
  };

  return (
    <Select
      label={label}
      name={FIELD_NAME_BUBBLE_SELECT}
      selectItems={selectItems}
      selectProps={{
        "data-testid": "form-field-bubble-select",
        required,
        ...selectProps,
      }}
      validate={(value, _, meta) => {
        if (meta?.modified && required && !value) {
          return getRequiredMessage();
        }

        return "";
      }}
      {...props}
    />
  );
};
